"use strict";
import Immutable from "immutable";
import _ from "underscore";
var makeCursor = function(data, keyPath, onChange) {
  return {
    valueOf: function() {
      return keyPath.length ? data.getIn(keyPath) : data;
    },
    update: function(updater) {
      return onChange(
        keyPath.length ? data.updateIn(keyPath, updater) : updater(data)
      );
    }
  };
};
var ReactCursor = function(component, keys) {
  if (Immutable.Map.isMap(component.state)) {
    return pureCursor(component, keys);
  } else {
    var mixedKeys = keysForMixedCursor(component.state, keys);
    return mixedCursor(
      component,
      mixedKeys.keysToImmutable,
      mixedKeys.keysInImmutable
    );
  }
};
ReactCursor.update = function(cursor, value) {
  return function() {
    cursor.update(function() {
      return value;
    });
  };
};
export default ReactCursor;
var pureCursor = function(component, keys) {
  return makeCursor(component.state, keys || [], function(newState) {
    component.replaceState(newState);
  });
};
var mixedCursor = function(component, keysToImmutable, keysInImmutable) {
  var immutable = _.reduce(
    keysToImmutable,
    function(object, key) {
      return object[key];
    },
    component.state
  );
  return makeCursor(immutable, keysInImmutable || [], function(newData) {
    var newState = _.reduceRight(
      keysToImmutable,
      function(object, key) {
        var newObject = {};
        newObject[key] = object;
        return newObject;
      },
      newData
    );
    component.setState(newState);
  });
};
var keysForMixedCursor = function(object, keys) {
  var key = _.first(keys);
  if (Immutable.Map.isMap(object[key])) {
    return { keysToImmutable: [key], keysInImmutable: _.rest(keys) };
  } else {
    if (_.isEmpty(keys)) {
      throw "A cursor can only be created if an immutable map existsat some point in the key path";
    } else {
      var next = keysForMixedCursor(object[key], _.rest(keys));
      return {
        keysToImmutable: [key].concat(next.keysToImmutable),
        keysInImmutable: next.keysInImmutable
      };
    }
  }
};
